module.exports = __webpack_public_path__ + "img/index_title.53e478b9.png";